import Blockly from "blockly";
import helpers from "blocks/helpers";

Blockly.Blocks.SetX = {
  message0: "set x to %1",
  args0: [
    {
      type: "input_value",
      name: "x",
      check: "Number",
    },
  ],
  previousStatement: "Statement",
  nextStatement: "Statement",
};

Blockly.Blocks.SetX.init = function () {
  this.jsonInit(Blockly.Blocks.SetX);
};

Blockly.JavaScript.SetX = function (block) {
  const x = helpers.codeForArg("x", block);

  if (typeof x === "undefined") {
    return "";
  } else {
    return `visualisation.setX(${x});`;
  }
};
